L.Control.IssueFormControl = L.Control.extend({

    includes: ((typeof L.Evented !== 'undefined' && L.Evented.prototype) || L.Mixin.Events),

    initialize: function() {
        var el = L.DomUtil.get('help.reportAnIssue');
        el.addEventListener('click', function() {
            sidebar.open("issue");
        });

        var elAnother = L.DomUtil.get('linkReportAnotherIssue');
        elAnother.addEventListener('click', function() {
            L.DomUtil.get('issueForm').style.display = 'block';
            L.DomUtil.get('issueThanks').style.display = 'none';
        });

        var loc = L.DomUtil.get('issueLocation');
        loc.style.display = 'none';

        var radioPoor = L.DomUtil.get('radioPoor'),
            radioUnsafe = L.DomUtil.get('radioUnsafe');

        L.DomEvent.on(radioPoor,'click',function() {
            L.DomUtil.get('issueLocation').style.display = 'none';
        });

        L.DomEvent.on(radioUnsafe,'click',function() {
            L.DomUtil.get('issueLocation').style.display = 'block';
        });

        var form = L.DomUtil.get('issueForm');
        L.DomEvent.on(form, 'submit', this._submit);
    },

    reset: function() {
        L.DomUtil.get('radioPoor').checked = true;
        L.DomUtil.get('radioUnsafe').checked = false;
        L.DomUtil.get('issueLocation').style.display = 'none';
        L.DomUtil.get('inputIssueLocation').value = '';
        L.DomUtil.get('inputIssueCoords').value = '';
        L.DomUtil.get('inputIssueDetail').value = '';
        L.DomUtil.get('inputIssueEmail').value = '';
    },

    _submit: function(e) {
        var postData = {
           issue: L.DomUtil.get('radioPoor').checked ? 'Poor route' : 'Unsafe road',
           location: L.DomUtil.get('inputIssueLocation').value,
           coords: L.DomUtil.get('inputIssueCoords').value,
           detail: L.DomUtil.get('inputIssueDetail').value,
           email: L.DomUtil.get('inputIssueEmail').value,
           url: window.location.href
        };

        var http = new XMLHttpRequest();
        var url = '/ors/reportissue';
        http.open('POST', url, true);
        http.setRequestHeader('Content-type', 'application/json');

        http.onreadystatechange = L.bind(function() {
            if (http.readyState == 4) {
                if (http.status == 200) {
                    L.DomUtil.get('issueForm').style.display = 'none';
                    L.DomUtil.get('issueThanks').style.display = 'block';
                    this.reset();
                } else {
                    http.onerror();
                }
            }
        },this);

        http.onerror = L.bind(function(e) {
            console.log(e);
            alert('Could not submit issue report');
        }, this);

        http.ontimeout = http.onerror;
        http.send(JSON.stringify(postData));

        e.preventDefault();
        return false;
    },

    _selectLocation: function(e) {
        L.DomUtil.get('inputIssueLocation').value = e.latlng.lat.toFixed(5) + ',' + e.latlng.lng.toFixed(5);
        L.DomUtil.get('inputIssueCoords').value = e.latlng.lat.toFixed(5) + ',' + e.latlng.lng.toFixed(5);

        control.getPlan().options.geocoder.reverse(e.latlng, 67108864 /* zoom 18 */, function(rs) {
            if (rs.length > 0) {
                L.DomUtil.get('inputIssueLocation').value = rs[0].name;
            }
        }, this);
    },

    enableLocationSelection: function() {
        disableClickToAddPoint();
        map.on('click',this._selectLocation);
    },

    disableLocationSelection: function() {
        enableClickToAddPoint();
        map.off('click',this._selectLocation);
    }

});
